
import { defineComponent, computed } from "vue";
import { mapGetters, mapState } from "vuex";
import Sidebar from "@/views/layouts/includes/Sidebar.vue";
import Footer from "@/views/layouts/includes/Footer.vue";
import Header from "@/views/layouts/includes/Header.vue";
import Title from "@/views/layouts/includes/Title.vue";
import Loader from "@/components/utils/Loader.vue";
import { store, useStore } from "@/store";
import { Roles } from "@/helpers/enums/Roles";
import sidebarItems from "@/helpers/Sidebar";
import Page403 from "@/components/403/index.vue";
import AgRoleBanner from '@/components/ag-role-banner/index.vue';
import { AuthActionTypes } from "@/store/modules/auth/action-types";
export default defineComponent({
  name: "Default",
  setup() {
    const store = useStore();
    const sidebarStatus = computed(() => store.getters.sidebarStatus);
    const loader = computed(() => store.getters.loader);
    return {
      sidebarStatus,
      loader,
    };
  },
  components: { Title, Header, Footer, Sidebar, Loader, Page403, AgRoleBanner },
  data() {
    return {
      sidebarItems: sidebarItems,
      currentRoles: [],
    };
  },
  mounted() {
    const data = this.$route;
    const matchName = data.matched[1].name;
    let roleRoute: any = this.sidebarItems.find(
      (i: any) => i.name == matchName
    );
    localStorage.removeItem("changingScope");
    if (
      data.fullPath.includes("/administration") &&
      roleRoute &&
      roleRoute.children &&
      Array.isArray(roleRoute.children)
    ) {
      if (data.fullPath.includes("/policy-")) {
        roleRoute = {
          roles: [
            Roles.CompanyAdmin,
            Roles.SiteAdmin,
            Roles.GroupAdmin,
            Roles.SiteAudit,
            Roles.GroupAudit,
          ],
        };
      } else {
        roleRoute = roleRoute.children.filter((i: any) =>
          data.fullPath.includes(i.link)
        );
        const rules: any = [];
        if (Array.isArray(roleRoute)) {
          roleRoute.forEach((element) => {
            element.roles.forEach((roleItem: any) => {
              rules.push(roleItem);
            });
          });
          roleRoute = {
            roles: rules,
          };
        }
      }
    } else {
      if (
        this.$route.meta &&
        this.$route.meta.roles &&
        Array.isArray(this.$route.meta.roles)
      ) {
        roleRoute = {
          roles: this.$route.meta.roles,
        };
      }
    }

    if (roleRoute) {
      this.currentRoles = roleRoute.roles;
    } else {
      this.currentRoles = [];
    }
    try{
      if (!this.agmsTemplate || Object.keys(this.agmsTemplate).length === 0) {
        const ls = localStorage.getItem("agms_template");
        if (ls) {
          const parsed = JSON.parse(ls);
          if (parsed && typeof parsed === 'object') {
            store.dispatch(AuthActionTypes.SET_AGMS_TEMPLATE, parsed);
          }
        }
      }
    }catch(e){
      console.log(e);
    }
  },
  created() {
    if (
      this.$route.fullPath.indexOf("dashboard/company-overview") > -1 &&
      this.loggedInUser.role == Roles.AGMSAdmin
    ) {
      this.$router.push("/administration/manage-partners");
    }
  },
  computed: {
    ...mapGetters(["loggedInUser"]),
    ...mapState({
      agmsTemplate: (state: any) => state.auth.agmsTemplate,
    }),
    currentRole(): string | null {
      return (this as any).agmsTemplate?.template ?? null;
    },
    templatePolicy(): boolean {
      const routeName = this.$route.name as string | undefined;
      return [
        'templateFileTypesPolicy',
        'templateAppGroupManagement',
        'templateGlobalPolicy',
        'templateAppGroupDetail',
      ].includes(routeName || '');
    },
    checkRole() {
      if (localStorage.getItem("changingScope")) {
        return true;
      }
      if (!localStorage.getItem("realRole")) {
        return true;
      }
      let role = this.loggedInUser.role ? this.loggedInUser.role : "";
      if (localStorage.getItem("selectedRole")) {
        role = localStorage.getItem("selectedRole");
      }
      const roles: any[] =
        this.currentRoles && this.currentRoles.length ? this.currentRoles : [];

      if (roles && !roles.includes(role)) {
        return false;
      }

      return true;
    },
  },
});
